module.exports = __webpack_public_path__ + "static/media/cert.54ec5d6b.jpeg";